import { useState, useEffect } from 'react';

const useWalletBalance = () => {
  const [walletBalance, setWalletBalance] = useState(0);
  
  const walletAddress = 'r3ybnjAqPxM5sTs7ENBkD8tRss2m2F4s6v';
  const API_ENDPOINT = `https://api.xrpscan.com/api/v1/account/${walletAddress}`;

  const getWalletBalance = async () => {
    try {
      const response = await fetch(API_ENDPOINT);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await response.json();

      // Convert drops to XRP (1 XRP = 1,000,000 drops)
      const balanceInXRP = parseFloat(data.xrpBalance) || 0;
      setWalletBalance(Number(balanceInXRP.toFixed(2)));
    } catch (error) {
      console.error('Error fetching wallet balance:', error);
    }
  };

  useEffect(() => {
    getWalletBalance(); // Initial call
    
    const intervalId = setInterval(getWalletBalance, 30000);
    
    return () => clearInterval(intervalId); // Cleanup on unmount
  }, []);

  return walletBalance;
};

export default useWalletBalance;
